import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { AreaTreeStoreContext } from '../context'
import { AreaTreeStore } from '../store/interface'

export const useAreaTreeStore: UseStore<AreaTreeStore> = selector => {
  return useContextStore(AreaTreeStoreContext, selector)
}

export const useAreaTreeStoreApi = () => {
  return useContextStoreApi(AreaTreeStoreContext)
}
